export default __webpack_public_path__ + "static/icon-trusted-1m-customers-c727f43f2b81a1badaa08effcd65eaf7.png";